import rolePermissions from './rolePermissions';
import linkToYourCase from 'lib/builders/menuItems/itemYourCase';
import getHomepageForRole from './getHomepageForRole';
import {isInternalUser} from './rolesList';
import { canCompanyUserAccessTasks } from 'lib/util/companyTasksAccess';
import moment from 'moment';

const navBarMenuList = ({ currentUser }) => {
  const menus = [];

  if (currentUser) {
    const homepage = getHomepageForRole(currentUser.role);
    menus.push({ label: 'Home', link: homepage})

    const showTasks = isInternalUser(currentUser.role) || canCompanyUserAccessTasks(currentUser.role);
    if (showTasks) {
      const taskParams = new URLSearchParams({
        status: 'new',
        createdAtFrom: moment().subtract(6, 'months').format('YYYY-MM-DD'),
        createdAtTo: moment().format('YYYY-MM-DD'),
        sortBy: 'scheduled_datetime',
        sortDirection: 'asc'
      });
      menus.push({ label: "Tasks", link: `/tasks?${taskParams.toString()}` });
    }

    menus.push({ label: "Communication preferences", link: "/preferences/communication" });

    if (currentUser.complaintsCount === 1 && currentUser.activeComplaintId) {
      menus[0].link = `/complaints/${currentUser.activeComplaintId}`;
    }

    menus.push(linkToYourCase(currentUser));

    if (canCompanyUserAccessTasks(currentUser.role)) {
      menus.push({ label: "My work view", link: "/dashboard/company-workview" });
    }

    if (rolePermissions[currentUser.role]?.canViewDreDashboards
      && homepage !== '/dashboard/myworkview')
      menus.push({ label: "My work view", link: "/dashboard/myworkview" });

    if (rolePermissions[currentUser.role]?.allowedToCreateOwnNewCase)
      menus.push({ label: "Create a new case", link: "/apply" });

    if (rolePermissions[currentUser.role]?.allowedToSeeOSSignUp)
      menus.push({ label: "Create a new case", link: "/ossignup" });

    if (rolePermissions[currentUser.role]?.canViewAdmin)
      menus.push({ label: "Admin", link: "/admin" });

    menus.push({ label: "Sign Out", link: "/signout" });
  } else {
    menus.push({ label: "Sign Up", link: "/signup" });
    menus.push({ label: "Sign In", link: "/signin" });
  }

  return menus;
};

export default navBarMenuList;
